/**
 * @module EventsList
 */

import Component from '../base/Component';
import './styles.css';

/**
 * Название компонента.
 */
export default class EventsList extends Component {
    static className = 'events-list';
}
